import html2pdf from "html2pdf.js";

export function downloadPdf(elementId, filename, orientation = "portrait") {
  const el = document.getElementById(elementId);
  if (!el) return;
  const opt = {
    margin: 8,
    filename,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true, backgroundColor: "#ffffff" },
    jsPDF: { unit: "mm", format: "a4", orientation },
  };
  return html2pdf().set(opt).from(el).save();
}
